var _path, _ellipse, _circle, _circle2, _circle3, _circle4, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 232,
    viewBox: "0 0 283 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.5 146.818C8.5 109.69 34.5981 90.6726 63.7075 95.6873C63.7075 95.6873 76.9239 32 142.504 32C208.084 32 232.676 85.6192 232.676 104.945C253.17 104.945 274.5 128.785 274.5 153.26C274.5 180.938 249.071 202 224.479 202H68.7264C44.134 202 8.5 183.947 8.5 146.818Z",
    fill: "#FFF1EC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.5,
    cy: 186,
    rx: 60,
    ry: 8,
    fill: "#FFD4C7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 34,
    r: 4,
    stroke: "#FF7043",
    strokeOpacity: 0.6,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 50,
    r: 3,
    stroke: "#FF7043",
    strokeOpacity: 0.6,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 43,
    r: 2,
    stroke: "#FF7043",
    strokeOpacity: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 70,
    r: 2,
    stroke: "#FF7043",
    strokeOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.134 103.5C208.519 102.833 209.481 102.833 209.866 103.5L212.464 108C212.849 108.667 212.368 109.5 211.598 109.5H206.402C205.632 109.5 205.151 108.667 205.536 108L208.134 103.5Z",
    fill: "#FF7043",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.366 54.5004C173.135 54.5004 173.617 55.3338 173.232 56.0004L172.366 57.5004C171.981 58.1671 171.018 58.1671 170.634 57.5004L169.768 56.0004C169.383 55.3338 169.864 54.5004 170.634 54.5004L172.366 54.5004Z",
    fill: "#FF7043",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.626 96.9138C103.123 95.7648 104.255 95.021 105.507 95.021H178.243C179.495 95.021 180.627 95.7648 181.124 96.9138L194.937 128.835C195.143 129.309 195.228 129.827 195.185 130.343L192.547 162L192.35 164.355C192.215 165.983 190.854 167.234 189.221 167.234H94.5286C92.8957 167.234 91.5354 165.983 91.3998 164.355L91.2035 162L88.5654 130.343C88.5225 129.827 88.6074 129.309 88.8128 128.835L102.626 96.9138Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2035 162L91.3998 164.355C91.5354 165.983 92.8957 167.234 94.5286 167.234H189.221C190.854 167.234 192.215 165.983 192.35 164.355L192.547 162M91.2035 162L88.5654 130.343C88.5225 129.827 88.6074 129.309 88.8128 128.835L102.626 96.9138C103.123 95.7648 104.255 95.021 105.507 95.021H178.243C179.495 95.021 180.627 95.7648 181.124 96.9138L194.937 128.835C195.143 129.309 195.228 129.827 195.185 130.343L192.547 162M91.2035 162H192.547",
    stroke: "#FFA270",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0703 129.558H118.392C118.89 129.558 119.317 129.916 119.436 130.4C120.24 133.658 124.334 145.256 141.875 145.256C159.417 145.256 163.511 133.658 164.315 130.4C164.434 129.916 164.861 129.558 165.359 129.558H193.681",
    stroke: "#FF7043",
    strokeOpacity: 0.6,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.147 101.92C111.361 101.388 111.878 101.04 112.451 101.04H171.288C171.868 101.04 172.388 101.396 172.599 101.936L180.43 122.085C180.788 123.007 180.108 124.001 179.119 124.001H104.332C103.335 124.001 102.655 122.993 103.028 122.069L111.147 101.92Z",
    fill: "#FFF1EC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 140.305,
    y: 70,
    width: 4,
    height: 20,
    rx: 2,
    fill: "#FF7043",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 111.754,
    y: 73,
    width: 4,
    height: 20,
    rx: 2,
    transform: "rotate(-30 111.754 73)",
    fill: "#FF7043",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 170.281,
    y: 71,
    width: 4,
    height: 20,
    rx: 2,
    transform: "rotate(30 170.281 71)",
    fill: "#FF7043",
    fillOpacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86.8135,
    y: 77,
    width: 4,
    height: 16,
    rx: 2,
    transform: "rotate(45 86.8135 77)",
    fill: "#FF7043",
    fillOpacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 89.6426,
    y: 88.3145,
    width: 4,
    height: 16,
    rx: 2,
    transform: "rotate(135 89.6426 88.3145)",
    fill: "#FF7043",
    fillOpacity: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 111.158,
    y: 58.0013,
    width: 2,
    height: 8,
    rx: 1,
    transform: "rotate(45 111.158 58.0013)",
    fill: "#FF7043",
    fillOpacity: 0.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 112.571,
    y: 63.6569,
    width: 2,
    height: 8,
    rx: 1,
    transform: "rotate(135 112.571 63.6569)",
    fill: "#FF7043",
    fillOpacity: 0.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 43,
    width: 2,
    height: 12,
    rx: 1,
    fill: "#FF7043",
    fillOpacity: 0.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 48,
    width: 2,
    height: 12,
    rx: 1,
    transform: "rotate(90 208 48)",
    fill: "#FF7043",
    fillOpacity: 0.6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 210.135,
    y: 80.3047,
    width: 2,
    height: 12,
    rx: 1,
    transform: "rotate(30 210.135 80.3047)",
    fill: "#FF7043",
    fillOpacity: 0.6
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 213.697,
    y: 88.1348,
    width: 2,
    height: 12,
    rx: 1,
    transform: "rotate(120 213.697 88.1348)",
    fill: "#FF7043",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/Empty.8b59026bc711196d6d8abb79ff6be693.svg";
export { ForwardRef as ReactComponent };